<template>
  <b-row>
    <b-col lg="12" xl="12">
      <b-tabs active-nav-item-class="font-weight-bold text-uppercase text-danger" >
        <b-tab title="사용자 정보">
          <b-card>
            <div class="d-flex flex-wrap align-items-center">
              <div class="title mr-auto">
                세부 정보
              </div>
              <div class="col-xl-4 col-md-12  d-flex align-self-center">
                <span class="pull-right" v-if="!add && model.created_at">날짜 ({{model.created_at | sdate}} @ {{model.last_addr || '-'}})</span>
              </div>
            </div>
            <hr>
            <b-row class="row mb-2">
              <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
                <label class="col-form-label" label="Allow login" label-for="ph_use" v-b-tooltip.hover title="로그인 허용">
                  로그인 허용
                </label>
              </b-col>
              <b-col class="col-xl-4 col-md-12 d-flex align-self-center">
                <div class="checkbox-switch">
                  <input type="checkbox" class="input-checkbox disabled" name="Allow_login" id="Allow_login" checked=""  v-model="model.is_alive" :disabled="lock" />
                  <div class="checkbox-animate disabled">
                    <span class="checkbox-off">OFF</span>
                    <span class="checkbox-on">ON</span>
                  </div>
                </div>
              </b-col>
              <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
                <label class="col-form-label" label="Email verified" label-for="ph_active" v-b-tooltip.hover title="허용된 이메일">
                  허용된 이메일
                </label>
              </b-col>
              <b-col class="col-xl-4 col-md-12  d-flex align-self-center">
                <div class="checkbox-switch">
                  <input type="checkbox" class="input-checkbox disabled" name="Email_verified" id="Email_verified" checked="" v-model="model.is_verified" :disabled="lock" />
                  <div class="checkbox-animate disabled">
                    <span class="checkbox-off">OFF</span>
                    <span class="checkbox-on">ON</span>
                  </div>
                </div>
              </b-col>
            </b-row>
            <b-row class="mb-2">
              <b-col class="col-xl-2 col-md-12 d-flex align-self-center" v-if="model.id">
                <label class="col-form-label">
                  마지막 접속일
                </label>
              </b-col>
              <b-col class="col-xl-4 col-md-12  d-flex align-self-center" v-if="model.id">
                  <b-form-input type="text" :value="model.last_visit | datetime" plaintext></b-form-input>
              </b-col>
              <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
                <label class="col-form-label" for="ph_group" v-b-tooltip.hover title="권한">
                  권한
                  <span class="text-danger ml-1">*</span>
                </label>
              </b-col>
              <b-col class="col-xl-4 col-md-12  d-flex align-self-center">
                <v-select v-if="!lock" label="name" v-model="model.permissions" :options="codes.permissions_user"></v-select>
                <b-form-input type="text" v-if="lock" :value="model.permissions" plaintext></b-form-input>
              </b-col>
            </b-row>
            <b-row class="mb-2">
              <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
                  <label class="col-form-label" for="ph_nickname">
                    이름
                    <span class="text-danger ml-1">*</span>
                  </label>
                </b-col>
                <b-col class="col-xl-4 col-md-12  d-flex align-self-center">
                  <b-form-input type="text" id="ph_nickname" v-model="model.nickname" :plaintext="lock"></b-form-input>
              </b-col>
              <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
                <label class="col-form-label" for="ph_username" v-b-tooltip.hover title="사용자명은 이메일주소입니다.">
                  사용자명(아이디)
                  <span class="text-danger ml-1">*</span>
                </label>
              </b-col>
              <b-col class="col-xl-4 col-md-12  d-flex align-self-center">
                <b-form-input @change="auto_set_nickname($event, model.username)" type="text" id="ph_username" v-model="model.username" :plaintext="lock"></b-form-input>
              </b-col>
            </b-row>
            <b-row class="mb-2" v-show="add || !lock">
              <b-col class="col-xl-2 col-md-12 d-flex align-self-center" >
                <b-form-group>
                  <label for="ph_pass">{{add ? '사용자' : '새'}} 비밀번호(*)</label>
                </b-form-group>
              </b-col>
              <b-col class="col-xl-10 col-md-12">
                <b-form-input type="password" id="ph_pass" v-model="model.new_password" :plaintext="lock"></b-form-input>
                <b-badge v-if="model.new_password"  :variant="password_policy('number') ? '성공' : '위험'"> 숫자 </b-badge>
                <b-badge v-if="model.new_password"  :variant="password_policy('uppercase') ? '성공' : '위험'"> 대문자 </b-badge>
                <b-badge v-if="model.new_password"  :variant="password_policy('lowercase') ? '성공' : '위험'"> 소문자 </b-badge>
                <b-badge v-if="model.new_password"  :variant="password_policy('spacial') ? '성공' : '위험'"> 특수 문자 </b-badge>
                <b-badge v-if="model.new_password"  :variant="password_policy('length') ? '성공' : '위험'">
                  최소 길이 : 10글자
                </b-badge>
              </b-col>
            </b-row>
            <b-row class="mb-2" v-if="model.new_password">
              <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
                <b-form-group>
                  <label for="ph_pass2">비밀번호 확인<span class="text-danger ml-1">*</span></label>
                </b-form-group>
              </b-col>
              <b-col class="col-xl-10 col-md-12">
                <b-form-input type="password" id="ph_pass2" v-model="model.new_password_repeat"  :plaintext="lock"></b-form-input>
              </b-col>
            </b-row>
            <hr>
            <b-badge variant="warning"> 안내 </b-badge>
            : 비밀번호를 공란으로 설정한 경우 48시간 동안 비밀번호 재설정 링크를 보내주세요.
            <hr>
            <b-row class="mb-4">
              <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
                <b-form-group>
                  <label for="ph_group" v-b-tooltip.hover title="단일 IP 또는 네트워크 범위를 입력하세요, etc) 192.168.0.100, 192.168.0.0/24 ">허용된 IP 주소들</label>
                </b-form-group>
              </b-col>
              <b-col class="col-xl-10 col-md-12">
                <b-form-textarea ref="allow_ip_list" :rows="model && model.allow_ip ? model.allow_ip.length + 2 : 0" max-rows="10" v-model="model.allow_ip_list" :plaintext="lock"></b-form-textarea>
              </b-col>
            </b-row>
            <!-- start group info -->
            <div class="d-flex flex-wrap align-items-center mt-5">
              <div class="title mr-auto" v-if="model.group.id">
                그룹<span class="text-danger ml-1">*</span>
              </div>
            </div>
            <hr v-if="model.group.id">
            <b-row class="mb-2" v-if="model.group.id">
              <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
                <label class="col-form-label" for="ph_name">그룹 이름</label>
              </b-col>
              <b-col class="col-xl-10 col-md-12">
                <b-form-input md=12 type="text" id="ph_name" v-model="model.group.groupname" :disabled="true"></b-form-input>
              </b-col>
            </b-row>
            <b-row class="mb-2" v-if="model.group.id">
              <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
                <label class="col-form-label" for="ph_service" v-b-tooltip.hover title="Service">서비스</label>
              </b-col>
              <b-col class="col-xl-4 col-md-12  d-flex align-self-center">
                <v-select v-if="add" :disabled="true" label="name" v-model="model.group.service" :options="codes.service_name"></v-select>
                <h4 v-else>
                  <b-badge  :variant="model.group.service == 'Basic' ? 'info' : 'success'"> {{model.group.service}} </b-badge>
                </h4>
              </b-col>
              <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
                <label class="col-form-label" label="Verified" label-for="ph_use">
                  확인
                </label>
              </b-col>
              <b-col class="col-xl-4 col-md-12  d-flex align-self-center">
                <div class="checkbox-switch">
                  <input type="checkbox" class="input-checkbox disabled" name="Email_verified" id="Email_verified" checked="" v-model="model.group.is_verified" :disabled="true" />
                  <div class="checkbox-animate disabled">
                    <span class="checkbox-off">OFF</span>
                    <span class="checkbox-on">ON</span>
                  </div>
                </div>
              </b-col>
            </b-row>
            <b-row class="mb-2">
              <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
                <label class="col-form-label" label="Member's" label-for="ph_count">
                  회원 수
                </label>
              </b-col>
              <b-col class="col-xl-4 col-md-12  d-flex align-self-center">
                {{model.group.count || 0}}
              </b-col>
              <b-col class="col-xl-2 col-md-12 d-flex align-self-center" v-if="model.group.id">
                <label class="col-form-label" for="ph_email" v-b-tooltip.hover title="Email">이메일</label>
              </b-col>
              <b-col class="col-xl-4 col-md-12  d-flex align-self-center" v-if="model.group.id">
                <b-form-input type="text" id="ph_email" :value="model.group.email" v-model="model.group.email" :disabled="true"></b-form-input>
              </b-col>
            </b-row>
            <b-row class="mb-2" v-if="model.group.id">
              <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
                <label class="col-form-label" label="contact" label-for="ph_contact" v-b-tooltip.hover title="컨택트">
                  컨택트
                </label>
              </b-col>
              <b-col class="col-xl-4 col-md-12  d-flex align-self-center">
                <b-form-input type="text" id="ph_contact" :value="model.group.contact" v-model="model.group.contact" :disabled="true"></b-form-input>
              </b-col>
              <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
                <label class="col-form-label" for="ph_address">
                  주소
                </label>
              </b-col>
              <b-col class="col-xl-4 col-md-12  d-flex align-self-center">
                <b-form-input md=12 type="text" id="ph_address" v-model="model.group.address" :disabled="true"></b-form-input>
              </b-col>
            </b-row>
            <div class="d-flex flex-wrap align-items-center mt-5">
              <div class="title mr-auto"  v-if="model.group.id">
                지역
              </div>
            </div>
            <hr>
            <b-row v-if="model.group.id">
              <b-col md="4">
                <b-form-group label="국가" label-for="ph_country" v-b-tooltip.hover title="국가">
                  <v-select :readonly="true" :disabled="true" label="name" v-model="region.country" :options="codes.country" ></v-select>
                </b-form-group>
              </b-col>
              <b-col md="4">
                <b-form-group label="언어" label-for="ph_language" v-b-tooltip.hover title="언어">
                  <v-select :readonly="true" :disabled="true" label="name" v-model="region.language" :options="codes.language"></v-select>
                </b-form-group>
              </b-col>
              <b-col md="4">
                <b-form-group label="시간대" label-for="ph_timezone" v-b-tooltip.hover title="시간대">
                  <v-select :readonly="true" :disabled="true" label="name" v-model="region.timezone" :options="codes.timezone" ></v-select>
                </b-form-group>
              </b-col>
            </b-row>
          </b-card>
        </b-tab>
        <b-tab title="로그인 로그" border-variant="primary" :disabled="!model.id">
          <!-- 해당 사용자의 로그인 목록 -->
          <log-Login-List v-if="model.id" :user="model"></log-Login-List>
        </b-tab>
        <!-- 해당 사용자의 액션 목록 -->
        <!-- <b-tab title="Log Action" border-variant="primary" :disabled="!model.id">
          <log-Action-List v-if="model.id" :user="model"></log-Action-List>
        </b-tab> -->
        </b-tabs>
      </b-col>
    </b-row>
</template>

<script>
  import App from './app.js'; export default Object.assign({}, App);
</script>